import React from 'react'
import AddressSearchDialogContent from '../../../routes/address/AddressSearchDialogContent'
import { PAGE_CLASSES } from '../../../routes/pageClasses.constants'
import { selectZone } from '../../../store/address/address.selectors'
import { MAP_MODES } from '../../../store/map/map.constants'
import AddressHeaderForm from '../../address/AddressHeaderForm'
import Page from '../../genericComponents/Page'
import Header from '../../header/Header'
import Main from '../../main/Main'
import Map from '../../map/Map'
import PushNotificationPopup from '../../PushNotification/PushNotificationPopup'
import SearchDialog from '../../search/SearchDialog'
import AddressSuggestContent from '../../suggest/AddressSuggestContent'
import DepartmentMapImage from './DepartmentMapImage'
import LayerZoneMainContent from './LayerZoneMainContent'
import LayerZoneMetaManager from './LayerZoneMetaManager'
import RegionMapImage from './RegionMapImage'

export const renderPage = ({ routeContext }) => {
  const { LayerPage, withToaster } = PAGE_CLASSES
  const { isDepartment } = selectZone(routeContext.store.getState())

  return (
    <Page cssClasses={[LayerPage, withToaster]} key="Page">
      <LayerZoneMetaManager layer={MAP_MODES.bicycle} />
      <Map key="Map" staticMap={isDepartment ? <DepartmentMapImage /> : <RegionMapImage />} />
      <Header key="Header" transparent>
        <AddressHeaderForm key="AddressHeaderForm" transparent />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<AddressSuggestContent />}>
        <AddressSearchDialogContent />
      </SearchDialog>
      <PushNotificationPopup />
      <Main key="Main" withoutSubHeader>
        <LayerZoneMainContent layer={MAP_MODES.bicycle} />
      </Main>
    </Page>
  )
}
